<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="country.id === null">{{ 'NEWCOUNTRY' | translate }}</span>
            <span *ngIf="country.id !== null">{{ 'EDITCOUNTRY' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="countryForm" id="countryForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="countryForm" >
            <input type="hidden" name="id" id="countryId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="countryName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="countryName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="countryForm.controls['name'].invalid && (countryForm.controls['name'].dirty || countryForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="countryForm.controls['name'].errors !== null">
                  <div *ngIf="countryForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="countryNameAr" formControlName="nameAr" type="text" pInputText [required]="false"> 
                      <label for="countryNameAr" class="">{{ 'NAMEAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="countryNameFr" formControlName="nameFr" type="text" pInputText [required]="false"> 
                      <label for="countryNameFr" class="">{{ 'NAMEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="countryPicture" formControlName="picture" type="text" pInputText [required]="false"> 
                      <label for="countryPicture" class="">{{ 'PICTURE' | translate }}</label>
                    </span>
                    <button type="button" pButton pRipple icon="pi pi-folder" styleClass="p-button-info" (click)="openFilerDialog('picture')"></button> 
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-shortcode"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="countryCode" formControlName="code" type="text" pInputText [required]="true"> 
                      <label for="countryCode" class="req">{{ 'CODE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="countryForm.controls['code'].invalid && (countryForm.controls['code'].dirty || countryForm.controls['code'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="countryForm.controls['code'].errors !== null">
                  <div *ngIf="countryForm.controls['code'].errors.required">
                   {{ 'CODEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-shortcode"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="countryLongCode" formControlName="longCode" type="text" pInputText [required]="true"> 
                      <label for="countryLongCode" class="req">{{ 'LONGCODE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="countryForm.controls['longCode'].invalid && (countryForm.controls['longCode'].dirty || countryForm.controls['longCode'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="countryForm.controls['longCode'].errors !== null">
                  <div *ngIf="countryForm.controls['longCode'].errors.required">
                   {{ 'LONGCODEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="countryPrefix" formControlName="prefix" type="text" pInputText [required]="false"> 
                      <label for="countryPrefix" class="">{{ 'PREFIX' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="countryPublished" formControlName="published" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="countryPublished" class="p-d-inline-block p-ml-2 ">{{ 'PUBLISHED' | translate }}</label>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKCOUNTRIES' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="country.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!countryForm.valid || disableSubmit"> <!--  [disabled]="countryForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!countryForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

